import React from 'react';
const WhyAiStrategy = () => {
    return (
        <div
            className="section-py bg-grey dark:bg-black border-b"
            style={{
                borderImageSource: 'linear-gradient(270deg, rgba(60, 69, 97, 0) 0%, #3C4561 50%, rgba(60, 69, 97, 0) 100%)',
                borderImageSlice: 1,
            }}
        >
            <div className="container xl:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="lg:col-span-6">
                        <h2 className="text-primary mb-4" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            Why Choose AI Strategy & Consulting?
                        </h2>
                        <p
                            className="text-secondary mb-0 dark:text-[#D7DEE5]"
                            data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200"
                        >
                            AI is no longer optional; it&apos;s a critical competitive imperative for businesses today. Despite this, many organizations struggle to scale AI beyond experimental pilots into enterprise-level transformations. The disconnect between AI hype and tangible business results creates confusion among executives about where and how to invest. IT teams face overwhelming technology choices, and business units experience slow, disjointed progress.
                        </p>
                    </div>
                    <div className="lg:col-span-6">
                        <p className="mb-4 dark:text-[#D7DEE5]"
                        data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200">
                            Common barriers include a lack of clear AI vision aligned with business goals, failed pilots that never reach production, disconnected efforts causing redundancy, difficulty quantifying AI&apos;s business value and ROI, skills gaps, organizational resistance, and premature technology investments. These challenges lead to budget waste and increased vulnerability to AI-native disruptors.
                        </p>
                        <p className="mb-0 dark:text-[#D7DEE5]"
                        data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200">
                            Typical scenarios calling for AI Strategy & Consulting include manufacturing firms needing AI roadmaps for predictive maintenance, retail chains exploring customer personalization strategies, financial institutions assessing AI readiness and compliance, healthcare providers prioritizing clinical AI applications, and enterprises transforming legacy analytics into AI-driven frameworks.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default WhyAiStrategy;
